import React from "react";

const leftD =
  "M4.41436 9.99995L10.7073 16.2928L9.29304 17.7071L0.585938 8.99995L9.29304 0.292847L10.7073 1.70706L4.41436 7.99995H19.0002V9.99995H4.41436Z";
const rightD =
  "M9.72386 6.66666H0V5.33332H9.72386L5.5286 1.13806L6.4714 0.195251L12.2761 5.99999L6.4714 11.8047L5.5286 10.8619L9.72386 6.66666Z";

/**
 * Arrow component for displaying directional arrows
 * @param {Object} props - Component props
 * @param {string} [props.direction='right'] - Direction of the arrow ('right' or 'left')
 * @param {string} [props.color='black'] - Color of the arrow
 * @param {number} [props.size=12] - Size of the arrow
 * @param {string} [props.className=''] - Additional CSS class names
 * @returns {React.ReactElement} Arrow component
 */
export const Arrow = ({
  color = "black",
  size = 12,
  direction = "right",
  className = "",
}) => {
  const pathD = direction === "right" ? rightD : leftD;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path fillRule="evenodd" clipRule="evenodd" d={pathD} fill={color} />
    </svg>
  );
};
